import React from 'react';
import styles from './mini-business-card.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { IBusinessInfoDto } from 'shared/api/business/interfaces/business-info-dto.interface';
import { CircleImage } from 'shared/ui';
import { useAppMediaQuery } from 'shared/hooks';

interface MiniBusinessCardProps {
  cardInfo: IBusinessInfoDto;
}

const LocationIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 9.9575C1 5.01069 5.02975 1 10 1C14.9703 1 19 5.01069 19 9.9575C19 14.8658 16.1279 20.5947 11.6459 22.6419C11.1307 22.8777 10.5688 23 10 23C9.43116 23 8.86928 22.8777 8.35412 22.6419C3.87212 20.5936 1 14.8669 1 9.9586V9.9575Z"
      stroke="#4caf50"
      strokeWidth="1.5"
    />
    <path
      d="M9.889 13C11.7299 13 13.2223 11.5348 13.2223 9.72732C13.2223 7.91984 11.7299 6.45459 9.889 6.45459C8.04805 6.45459 6.55566 7.91984 6.55566 9.72732C6.55566 11.5348 8.04805 13 9.889 13Z"
      stroke="#4caf50"
      strokeWidth="1.5"
    />
  </svg>
);

const PersonIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="8" r="4.5" stroke="#4caf50" strokeWidth="1.5" />
    <path
      d="M3 22C3 17.0294 7.02944 13 12 13C16.9706 13 21 17.0294 21 22"
      stroke="#4caf50"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const GearIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="3.5" stroke="#4caf50" strokeWidth="1.5" />
    <path
      d="M12 1V4M12 20V23M1 12H4M20 12H23M4.93 4.93L7.05 7.05M16.95 16.95L19.07 19.07M4.93 19.07L7.05 16.95M16.95 7.05L19.07 4.93"
      stroke="#4caf50"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MiniBusinessCard: React.FC<MiniBusinessCardProps> = ({
  cardInfo,
}) => {
  const navigate = useNavigate();
  const isTablet = useAppMediaQuery('tablet');

  const handleNavigateClick = () => {
    const path = AppLinks.BusinessLink.replace(':id', String(cardInfo.id));
    navigate(path);
  };

  return (
    <div
      key={cardInfo.id}
      className={styles.business_card}
      onClick={handleNavigateClick}
    >
      <div className={styles.business_card__content}>
        <div className={styles.content__left_block}>
          <CircleImage imgSrc={cardInfo.logoUrl} imgSize={isTablet ? 40 : 60} />
          <div className={styles.left_block__title}>{cardInfo.name}</div>
        </div>
        <div className={styles.content__middle_line}>
          <div className={styles.middle_line__line}></div>
        </div>
        <div className={styles.content__right_block}>
          <div className={styles.right_block__info}>
            <div className={styles.info__item}>
              <span className={styles.info__icon}>
                <LocationIcon />
              </span>
              <span>Точек: </span>
              <span className={styles.info__value}>
                {cardInfo.pointCount || 0}
              </span>
            </div>
            <div className={styles.info__item}>
              <span className={styles.info__icon}>
                <PersonIcon />
              </span>
              <span>Управляющих: </span>
              <span className={styles.info__value}>
                {cardInfo.administratorCount || 0}
              </span>
            </div>
            <div className={styles.info__item}>
              <span className={styles.info__icon}>
                <GearIcon />
              </span>
              <span>Менеджеров: </span>
              <span className={styles.info__value}>
                {cardInfo.managerCount || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
